var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fab532;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #7c2c87;\n      }\n\n      .cls-3 {\n        fill: #8b2d87;\n      }\n\n      .cls-4 {\n        fill: #154955;\n      }\n\n      .cls-5 {\n        fill: #d4102b;\n      }\n\n      .cls-6 {\n        fill: #d51878;\n      }\n\n      .cls-7 {\n        fill: #e02b59;\n      }\n\n      .cls-8 {\n        fill: #ce1762;\n      }\n\n      .cls-9 {\n        fill: #ca1b7b;\n      }\n\n      .cls-10 {\n        fill: #b22b86;\n      }\n\n      .cls-11 {\n        fill: #de0a14;\n      }\n\n      .cls-12 {\n        fill: #c21b7d;\n      }\n\n      .cls-13 {\n        fill: #b32a87;\n      }\n\n      .cls-14 {\n        fill: #c5171c;\n      }\n\n      .cls-15 {\n        fill: #b91c7e;\n      }\n\n      .cls-16 {\n        fill: #b91b7f;\n      }\n\n      .cls-17 {\n        fill: #991b7a;\n      }\n\n      .cls-18 {\n        fill: #7f195a;\n      }\n\n      .cls-19 {\n        fill: #822a86;\n      }\n\n      .cls-20 {\n        fill: #f39036;\n      }\n\n      .cls-21 {\n        fill: #f0823a;\n      }\n\n      .cls-22 {\n        fill: #ef7c3c;\n      }\n\n      .cls-23 {\n        fill: #eb5a47;\n      }\n\n      .cls-24 {\n        fill: #e52e16;\n      }\n\n      .cls-25 {\n        fill: #e52d1a;\n      }\n\n      .cls-26 {\n        fill: #e72b65;\n      }\n\n      .cls-27 {\n        fill: #e52f18;\n      }\n\n      .cls-28 {\n        fill: #ee7141;\n      }\n\n      .cls-29 {\n        fill: #fcc039;\n      }\n\n      .cls-30 {\n        fill: #e84627;\n      }\n\n      .cls-31 {\n        fill: #fbdb3f;\n      }\n\n      .cls-32 {\n        fill: #ec641f;\n      }\n\n      .cls-33 {\n        fill: #ec6320;\n      }\n\n      .cls-34 {\n        fill: #ec634b;\n      }\n\n      .cls-35 {\n        fill: #ec634a;\n      }\n\n      .cls-36 {\n        fill: #f28f49;\n      }\n\n      .cls-37 {\n        fill: #ec641d;\n      }\n\n      .cls-38 {\n        fill: #ea514f;\n      }\n\n      .cls-39 {\n        fill: #fbba39;\n      }\n\n      .cls-40 {\n        fill: #f49930;\n      }\n\n      .cls-41 {\n        fill: #f69f32;\n      }\n\n      .cls-42 {\n        fill: #f59e37;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "163.6 152.33 126.41 56.36 163.6 77.31 163.6 152.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "240.68 119.97 163.6 152.33 163.6 77.31 240.68 119.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "229.86 178.01 163.6 152.33 240.68 119.97 229.86 178.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "260.96 188.82 229.86 178.01 240.68 119.97 260.96 188.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "293.42 149.62 260.96 188.82 240.68 119.97 293.42 149.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "336.69 172.6 260.96 188.82 293.42 149.62 336.69 172.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M370.5,230.72c-10.82,0-109.54-41.9-109.54-41.9l75.73-16.22,33.81,58.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "440.82 230.72 370.5 230.72 336.69 172.6 440.82 230.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "267.05 207.09 289.36 268.57 228.51 198.28 267.05 207.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "298.83 214.35 289.36 268.57 267.05 207.09 298.83 214.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "336.69 223 289.36 268.57 298.83 214.35 336.69 223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "370.5 230.72 289.36 268.57 336.69 223 370.5 230.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "405.66 286.14 289.36 268.57 370.5 230.72 405.66 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "461.11 286.14 405.66 286.14 370.5 230.72 461.11 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "440.82 230.72 461.11 286.14 370.5 230.72 440.82 230.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "467.87 218.56 485.45 268.57 440.82 230.72 467.87 218.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "461.11 286.14 485.45 268.57 440.82 230.72 461.11 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "467.87 218.56 485.45 268.57 478.69 163.14 467.87 218.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "444.88 163.14 478.69 163.14 478.69 122.12 444.88 163.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "432.71 144.22 423.24 175.3 444.88 163.14 432.71 144.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "478.69 122.12 432.71 144.22 444.88 163.14 478.69 122.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "573.35 76.63 478.69 122.12 544.15 115.83 573.35 76.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "544.15 115.83 478.69 122.12 526.02 140.16 544.15 115.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "478.69 163.14 526.02 140.16 478.69 122.12 478.69 163.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "565.24 230.72 536.84 217.21 511.42 268.57 565.24 230.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "565.24 230.72 626.09 234.78 663.96 173.95 565.24 230.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "663.96 173.95 742.92 188.82 626.09 234.78 663.96 173.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "835.03 152.33 769.74 178.01 759.3 122.59 835.03 152.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "836.38 78.22 759.3 122.69 835.03 152.33 836.38 78.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "835.03 152.33 836.38 78.22 875.45 56.66 835.03 152.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "950 14.84 835.03 152.33 875.45 56.66 950 14.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "742.39 188.82 708.91 149.62 663.42 173.95 742.39 188.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "759.3 122.59 708.76 149.62 742.25 188.82 759.3 122.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "742.29 188.82 769.78 178.01 759.33 122.59 742.29 188.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "329.93 286.14 405.66 286.14 390.79 340.21 329.93 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "461.11 286.14 405.66 286.14 390.79 340.21 461.11 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "473.28 348.32 485.45 268.57 461.11 286.14 473.28 348.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "390.79 340.21 433.26 344.39 461.11 286.14 390.79 340.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "433.26 344.39 473.28 348.32 461.11 286.14 433.26 344.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "473.28 348.32 499.42 308.45 531.43 348.32 473.28 348.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "485.45 268.57 499.42 308.45 473.28 348.32 485.45 268.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "593.64 286.14 613.92 338.86 538.33 286.14 593.64 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "511.42 268.57 538.33 286.14 531.43 348.32 511.42 268.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "565.24 344.44 613.92 338.86 538.33 286.14 565.24 344.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "626.09 234.78 538.33 286.14 593.64 286.14 626.09 234.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "626.09 234.78 538.33 286.14 565.24 230.72 626.09 234.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "511.42 268.57 499.42 308.45 485.45 268.57 511.42 268.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "531.43 348.32 499.42 308.45 511.42 268.57 531.43 348.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "511.42 268.57 538.33 286.14 565.24 230.72 511.42 268.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "536.84 217.21 526.02 140.16 511.42 268.57 536.84 217.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "485.45 268.57 511.42 268.57 478.69 163.14 485.45 268.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "531.43 348.32 538.33 286.14 565.24 344.44 531.43 348.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "673.42 286.14 613.92 338.86 593.64 286.14 673.42 286.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "626.09 234.78 593.64 286.14 712.64 269.92 626.09 234.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "772.14 196.93 712.64 269.92 732.95 207.09 772.14 196.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "626.09 234.78 712.64 269.92 669.37 223.56 626.09 234.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "732.95 207.09 704.93 214.35 712.64 269.92 732.95 207.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "669.37 223.56 704.93 214.35 712.64 269.92 669.37 223.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "163.6 152.33 50 14.45 126.41 56.36 163.6 152.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "478.69 163.14 526.02 140.16 511.42 268.57 478.69 163.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "473.28 348.32 476.66 368.6 498.43 348.32 473.28 348.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "526.02 366.57 498.43 348.32 531.43 348.32 526.02 366.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "476.66 368.6 502.35 405.09 498.43 348.32 476.66 368.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "526.02 366.57 502.35 405.09 498.43 348.32 526.02 366.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "481.05 498.47 454.68 650.42 440.82 597.99 481.05 498.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "502.35 405.11 459.76 445.04 476.66 368.6 502.35 405.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "440.82 597.99 432.71 567.29 481.05 498.47 440.82 597.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "459.76 445.02 486.35 467.95 502.35 405.09 459.76 445.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "432.71 567.29 453.67 472.53 481.05 498.47 432.71 567.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "459.76 445.02 481.05 498.47 486.35 467.95 459.76 445.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "453.67 472.53 459.76 445.02 481.05 498.47 453.67 472.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "502.35 405.09 548.33 460.24 526.02 366.57 502.35 405.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "486.35 467.95 503.03 534.85 469.4 597.99 486.35 467.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "502.35 405.09 548.33 460.24 517.46 467.11 502.35 405.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "547.08 649.9 524.94 513.24 563.02 598.55 547.08 649.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "548.33 460.24 524.94 513.24 554.37 485.58 548.33 460.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "563.02 598.55 573.21 565.27 524.94 513.24 563.02 598.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "554.37 485.58 573.35 565.27 524.94 513.24 554.37 485.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "469.4 597.99 455.7 703.14 503.03 534.85 469.4 597.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "517.46 467.11 503.03 534.85 535.8 619 517.46 467.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "535.8 619 455.7 703.14 539.88 661.07 535.8 619"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "544.15 705.17 503.03 732.2 539.88 661.07 544.15 705.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "544.15 705.17 499.42 828.85 503.03 732.2 544.15 705.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "455.7 703.14 499.42 828.85 503.03 732.2 455.7 703.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "535.8 619 455.7 703.14 503.03 534.85 535.8 619"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "486.35 467.95 503.03 534.85 517.46 467.11 486.35 467.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "502.35 405.09 517.46 467.11 486.35 467.95 502.35 405.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "455.7 703.06 503.03 732.2 539.88 661.07 455.7 703.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "525.37 510.92 522.98 498.36 548.33 460.24 525.37 510.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "517.46 467.11 522.62 498.9 548.33 460.24 517.46 467.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "524.94 513.24 522.62 498.9 548.33 460.24 524.94 513.24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.49,998.03l52.38-116.23h19.73l52.38,116.23h-21.17l-9.15-20.09h-63.86l-9.15,20.09h-21.17ZM61.98,961.43h49.51l-13.63-29.42c-1.56-3.35-3.26-7.35-5.11-12.02-1.86-4.66-3.32-8.43-4.39-11.3l-1.61-4.48c-3.83,10.76-7.53,20.03-11.12,27.8l-13.63,29.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M162.96,998.03v-116.23h21.17l41.61,57.04c2.39,3.35,5.08,7.33,8.07,11.93,2.99,4.61,5.32,8.34,7,11.21l2.69,4.31v-84.48h20.81v116.23h-21.52l-39.64-54.17c-2.99-4.06-6.1-8.58-9.33-13.54-3.23-4.96-5.74-8.88-7.53-11.75l-2.51-4.31v83.77h-20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M290.14,998.03v-116.23h20.81v68.7c5.02-7.18,9.21-12.8,12.56-16.86l41.61-51.84h24.57l-42.87,54.35,47.35,61.88h-24.39l-36.05-47.53-22.78,27.44v20.09h-20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M397.04,998.03l52.38-116.23h19.73l52.38,116.23h-21.17l-9.15-20.09h-63.86l-9.15,20.09h-21.17ZM434.53,961.43h49.51l-13.63-29.42c-1.56-3.35-3.26-7.35-5.11-12.02-1.86-4.66-3.32-8.43-4.39-11.3l-1.61-4.48c-3.83,10.76-7.53,20.03-11.12,27.8l-13.63,29.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M530.14,983.14l8.07-15.78c11.24,9.09,24.1,13.63,38.57,13.63,6.7,0,12.56-1.49,17.58-4.49,5.02-2.99,7.53-6.99,7.53-12.02,0-3.35-1.32-6.19-3.95-8.52-2.63-2.33-5.32-3.97-8.07-4.93-2.75-.96-6.7-2.03-11.84-3.23-5.14-1.19-9.45-2.3-12.92-3.32-3.47-1.01-7.3-2.51-11.48-4.48-4.19-1.97-7.53-4.09-10.05-6.37-2.51-2.27-4.63-5.2-6.37-8.79-1.73-3.59-2.6-7.59-2.6-12.02,0-10.28,4.12-18.32,12.38-24.13,8.25-5.8,18.18-8.7,29.78-8.7,15.18,0,28.94,4.19,41.26,12.56l-8.07,15.96c-10.17-6.46-21.23-9.69-33.18-9.69-2.99,0-5.98.39-8.97,1.17-2.99.78-5.74,2.27-8.25,4.48-2.51,2.21-3.77,4.93-3.77,8.16,0,4.19,1.94,7.36,5.83,9.51,3.88,2.15,10.07,4.25,18.56,6.28,6.34,1.44,11.78,3.02,16.32,4.75,4.54,1.74,9.03,3.95,13.45,6.64,4.42,2.69,7.8,6.13,10.13,10.31,2.33,4.19,3.5,8.97,3.5,14.35,0,11.36-4.66,20.09-13.99,26.19-9.33,6.1-20.33,9.15-33,9.15-19.01,0-34.5-5.56-46.46-16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M656.32,897.4c11.66-11.6,26.22-17.4,43.68-17.4s32.02,5.8,43.68,17.4c11.66,11.6,17.49,25.77,17.49,42.51s-5.83,31.09-17.49,42.69c-11.66,11.6-26.22,17.4-43.68,17.4s-32.02-5.8-43.68-17.4c-11.66-11.6-17.49-25.83-17.49-42.69s5.83-30.91,17.49-42.51ZM700.18,981.17c11.12,0,20.45-4.04,27.98-12.11,7.53-8.07,11.3-17.79,11.3-29.15s-3.77-21.05-11.3-29.06c-7.53-8.01-16.86-12.02-27.98-12.02s-20.66,4.01-28.25,12.02c-7.6,8.01-11.39,17.7-11.39,29.06s3.79,21.08,11.39,29.15c7.59,8.07,17.01,12.11,28.25,12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M781.61,998.03v-116.23h85.56v17.94h-64.75v28.34h54.71v17.76h-54.71v52.2h-20.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M913.81,998.03v-98.3h-40.9v-17.94h102.6v17.94h-40.9v98.3h-20.81Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/new-logo.580e10c13fd6b27a3965fdf1b644bf54.svg";
export { ForwardRef as ReactComponent };